import MaskSelectorToolStyles from "./MaskSelectorToolStyles";
import {Box, Typography} from "@mui/material";
import {res_snc_1} from "ui-common/components/ResMedColours";
import React from "react";

const BulletPoint = ({ number, message }) => {

    const {classes} = MaskSelectorToolStyles();

    return (
        <Box display="flex" mb="30px" >
            <Box
                display="flex"
                justifyContent="center"
                alignSelf="center"
                bgcolor={res_snc_1}
                borderRadius="50%"
                minHeight={32}
                minWidth={32}
                fontSize="1.2rem"
                mr={1}
            >
                <Box color="#333333">{number}</Box>
            </Box>
            <Typography className={` ${classes.bulletText} ${classes.noOutline}`} display="inline" tabIndex="0" aria-label={message}>{message}</Typography>
        </Box>
    );
};

export default BulletPoint;